import { Card } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import ComingSoon from "../../assests/new-images/coming-soon.webp"

export default function ExchangeRateFeatureComponent() {

  const { t } = useTranslation();
  return (
    <>
      {" "}
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            <h3 className="title mb-0">
              {t("navigation.exchange_rate", {
                defaultValue: "Exchange Rates",
              })}
            </h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <img align="center"
              height={400}
              alt="ComingSoon"
              src={ComingSoon}
            />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h3 align="center" className="password-text">
              Stay Tuned, Something awesome is coming soon!!
            </h3>
          </div>
        </div>
      </Card>
    </>
  );
}
